/**
 * Centralized formatting utilities
 * Used across components for consistent display
 */

/**
 * Format an ability name for display (capitalize first letter)
 * @example formatAbility('strength') => 'Strength'
 */
export function formatAbility(ability: string): string {
  return ability.charAt(0).toUpperCase() + ability.slice(1);
}

/**
 * Format a skill name for display (capitalize each word, replace hyphens with spaces)
 * @example formatSkill('sleight-of-hand') => 'Sleight Of Hand'
 */
export function formatSkill(skill: string): string {
  return skill
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// Note: formatModifier is exported from @character-creator/core
// Re-export here for convenience in web app
export { formatModifier } from '@character-creator/core';

/**
 * Sanitize a character name - allows only safe characters
 * Removes HTML but keeps common name characters
 * Note: Only trims leading whitespace to allow typing "Firstname Lastname"
 */
export function sanitizeCharacterName(name: string): string {
  // Remove any HTML tags
  const stripped = name.replace(/<[^>]*>/g, '');
  // Keep only letters, numbers, spaces, hyphens, apostrophes
  // Only trim leading whitespace - trailing spaces are needed while typing
  return stripped.replace(/[^a-zA-Z0-9\s\-']/g, '').replace(/^\s+/, '');
}
